import {SOCKET_ROOM} from './socket.room'

export const SOCKET_CONNECT = 'SOCKET_CONNECT'
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT'

// INTERNAL STATE
export const SOCKET_QUEUE_COMMAND = 'SOCKET_QUEUE_COMMAND'

// AUTH
export const SOCKET_AUTHENTICATE = 'SOCKET_AUTHENTICATE'
export const SOCKET_AUTHENTICATED = 'SOCKET_AUTHENTICATED'

// outgoing
export const SOCKET_INITIALIZE_TRIP = 'INITIALIZE_TRIP'
export const SOCKET_LOAD_TRIP = 'LOAD_TRIP'
export const SOCKET_LUNA_CLONE = 'CLONE_LUNA'
export const SOCKET_UPDATE = 'UPDATE'

// incoming
export const SOCKET_RECV = 'SOCKET_RECV' // generic handler
export const SOCKET_RECV_UPDATE = 'RECV_UPDATE'
export const SOCKET_REJECT = 'SOCKET_REJECT'


// commit msg for socket
export const SET_COMMIT_MSG = 'SET_COMMIT_MSG'

// presence
export const PRESENCE_LIST = 'PRESENCE_LIST'
export const PRESENCE_JOIN = 'PRESENCE_JOIN'
export const PRESENCE_UPDATE = 'PRESENCE_UPDATE'
export const PRESENCE_LEAVE = 'PRESENCE_LEAVE'

// chat
export const CHAT_LOAD = 'CHAT_LOAD'
export const CHAT_RECV = 'CHAT_RECV'
// export const CHAT_SEND = 'CHAT_SEND' //do we need this? should be handled in chat.action?


export const socketConnect = () => {
    return {
        type: SOCKET_CONNECT
    }
}

export const socketDisconnect = () => {
    return {
        type: SOCKET_DISCONNECT
    }
}

export const socketQueueCommand = (socket, op, reverseOp, revision, author) => {
    return {
        type: SOCKET_QUEUE_COMMAND,
        socket,
        op,
        reverseOp,
        revision,
        author
    }
}

export const socketRecv = (message) => {  
    return {
        type: SOCKET_RECV,
        message
    }
}

// this is dispatched after receiving initial Laravel payload in index.js.
// type indicates to socket to make new trip json file.
export const socketInitializeTrip = (tripGuid, itineraryGuid, tripName, travelers, travelerGuid, name) => {
    return {
        type: SOCKET_INITIALIZE_TRIP,
        realtime: {
            room: SOCKET_ROOM.PLANNER
        },
        tripGuid, itineraryGuid, tripName, travelers, travelerGuid, name
    }
}

export const socketLunaClone = (tripGuid, itineraryGuid, cloneTripGuid, cloneItineraryGuid, tripName, travelers, travelerGuid, name) => {
    return {
        type: SOCKET_LUNA_CLONE,
        realtime: {
            room: SOCKET_ROOM.PLANNER
        },
        tripGuid, itineraryGuid, cloneTripGuid, cloneItineraryGuid, tripName, travelers, travelerGuid, name
    }
}

// this is dispatched when we need to load an existing trip
export const socketLoadTrip = (tripGuid, itineraryGuid, travelerGuid, name) => {
    return {
        type: SOCKET_LOAD_TRIP,
        realtime: {
            room: SOCKET_ROOM.PLANNER
        },
        tripGuid, itineraryGuid, travelerGuid, name
    }
}

export const socketAuthenticate = (travelerGuid) => {
    return {
        type: SOCKET_AUTHENTICATE,
        realtime: {
            room: SOCKET_ROOM.AUTH
        },
        travelerGuid
    }
}

export const socketUpdate = (op, revision, author) => {
    return {
        type: SOCKET_UPDATE,
        realtime: {
            room: SOCKET_ROOM.PLANNER
        },
        op,
        revision,
        author
    }
}

export const socketRecvUpdate = (socket, op, revision, author, traveler, commitMsg, commitHash, createdAt) => {
    return {
        type: SOCKET_RECV_UPDATE,
        ignoreJOTChange: true,
        socket,
        op,
        revision,
        author,
        traveler,
        commitMsg,
        commitHash,
        createdAt
    }
}

export function setCommitMsg(msg) {
    return {
        type: SET_COMMIT_MSG,
        msg
    }
}

export const socketReject = (socket, op, revision) => {
    return {
        type: SOCKET_REJECT,
        ignoreJOTChange: true,
        socket,
        op,
        revision,
    }
}

// PRESENCE
export const presenceList = (socket, presences) => {
    return {
        type: PRESENCE_LIST,
        ignoreJOTChange: true,
        socket,
        presences
    }
}

export const presenceJoin = (socket, presence) => {
    return {
        type: PRESENCE_JOIN,
        ignoreJOTChange: true,
        socket,
        presence
    }
}

export const presenceLeave = (socket, clientId) => {
    return {
        type: PRESENCE_LEAVE,
        ignoreJOTChange: true,
        socket,
        clientId
    }
}

export const presenceUpdate = (socket, presence) => {
    return {
        type: PRESENCE_UPDATE,
        ignoreJOTChange: true,
        socket,
        presence
    }
}

export const chatLoad = (socket, message) => {  
    // console.log('chat load')
    // console.log(message)
    return {
        type: CHAT_LOAD,
        ignoreJOTChange: true,
        socket,
        data: {
            'temporary_id': null, // no temp id from server load
            'message_id': message.id,
            'trip_id': message.trip_guid,
            'message': message.message,
            'sender_user_id': message.sender_guid,
            'sender_guid': message.sender_guid,
            'hashtag': message.hashtag,
            'mentions': message.mentions,
            'created_at': message.created_at
        }
    }
}

export const chatRecv = (socket, message) => {  
    // console.log('chat rec')
    // console.log(message)
    return {
        type: CHAT_RECV,
        ignoreJOTChange: true,
        socket,
        data: {
            'temporary_id': message.temporary_id,
            'message_id': message.message_id,
            'trip_id': message.trip_id,
            'message': message.message,
            'sender_user_id': message.sender_user_id,
            'sender_guid': message.sender_guid,
            'hashtag': message.hashtag,
            'mentions': message.mentions,
            'created_at': message.created_at
        }
    }
}
